module.exports = __webpack_public_path__ + "img/42_25.5922399b.png";